function manageExpandAccordions( result = document ){
    const ACCORDION_ITEMS = result.querySelectorAll(`.js-eachAccordion`);

    ACCORDION_ITEMS.forEach(accordionItem => {
        let trigger = accordionItem.querySelector(`.js-eachAccordion_title`),
            expandable = accordionItem.querySelector(`.js-eachAccordion_expandable`),
            calcHeight = accordionItem.querySelector(`.js-eachAccordion_content`).getBoundingClientRect().height;

        trigger.addEventListener('click', () => {
            if( expandable.classList.contains('expanded') ){
                expandable.style.height = 0;
                expandable.classList.remove('expanded');
            }else{
                expandable.style.height = `${calcHeight}px`;
                expandable.classList.add('expanded');
            }
        })
    });
}

function fecthItems( tag = "all", result, blog_id ){
    if( !result || !blog_id )
        return console.warn("🦆 Something went wrong: can't find the result container or blog ID");

    let options = {
		rootMargin: '0px',
		threshold: 0.20,
	}
	let observer = new IntersectionObserver(observerElements, options);

	function observerElements(entries) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('fade-in')
			}
		})
	}

    const FORM_DATA = new FormData();
    FORM_DATA.append('operation', 'getAccordionElements');
    FORM_DATA.append('tag', tag);
    FORM_DATA.append('blog_id', blog_id);

    fetch( `${site_url}ajax/functions.php`, { method: `POST`, body: FORM_DATA } )
    .then(response => response.json())
    .then(data => {
        if( data.err == false ){
            result.innerHTML = data.html;

            result.classList.remove('loading');
            result.querySelectorAll('.animate-fade').forEach((target) => {
                observer.observe(target);
            });

            manageExpandAccordions( result );
        }else{
            console.error(`🦆 Something went wrong getting the accordion items \n Message: ${data.err_msg}`);
        }
    })
    .catch(err => {
        console.error(`🦆 Something went wrong fetching the accordion items \n Message: ${err}`);
    });

}

function manageAccordionFilterFunctions() {
    const accordionModules = document.querySelectorAll(`.js-accordionFilter`);
    
    accordionModules.forEach(accordionModule => {
        const FILTER = accordionModule.querySelector(`.js-accordionFilter_filter`);
        const RESULT = accordionModule.querySelector(`.js-accordionFilter_result`);
        const BLOG_ID = accordionModule.getAttribute('data-blog_id');

        if( FILTER ){
            if( FILTER.querySelector(`select`) ){
                FILTER.querySelector(`select`).addEventListener('change', (e) => {
                    const filterValue = e.target.value;
                    RESULT.classList.add('loading');
                    fecthItems( filterValue, RESULT, BLOG_ID );
                })

                fecthItems( FILTER.querySelector(`option`).value, RESULT, BLOG_ID );
            }else{
                let beforeElementClicked = null;
                FILTER.addEventListener('click', (e) => {
                    const elementClicked = e.target;
                    if( elementClicked.nodeName === 'A' ){
                        e.preventDefault();
    
                        if( beforeElementClicked ){
                            beforeElementClicked.classList.remove('active');
                        }
    
                        RESULT.classList.add('loading');
                        const filterValue = elementClicked.getAttribute('data-tag');
                        fecthItems( filterValue, RESULT, BLOG_ID );
    
                        beforeElementClicked = elementClicked;
                        elementClicked.classList.add('active');
                    }
                })
    
                FILTER.querySelector(`a`).click();
            }
        }else{
            fecthItems( "", RESULT, BLOG_ID );
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
     if( document.querySelector(`.js-accordionFilter`) ){
        setTimeout(() => {
            manageAccordionFilterFunctions();
        }, 500);
    }
});